import React from "react"
import { FaHome, FaCog, FaDatabase, FaListUl, FaCheck, FaFileUpload, FaPhoneAlt, FaUser, FaRegBuilding, FaUserCog, FaEnvelope } from "react-icons/fa"
const user = JSON.parse(sessionStorage.getItem('user'))
let size = 15

const navigationSuperadminTop = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formconfig",
    title: "Setting",
    type: "collapse",
    icon: <FaCog size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formugoals",
        title: "Goals",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/goalsform"
      }
    ]
  },
  {
    id: "formuser",
    title: "Users",
    type: "collapse",
    icon: <FaUserCog size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formuser1",
        title: "User Form",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/userform"
      },
      {
        id: "salesMonth",
        title: "User Aux. Customer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/salesMonth"
      },
      /* {
        id: "formuser2",
        title: "Report",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportlogin"
      } */
    ]
  },
  {
    id: "formomabacare",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "formagency",
    title: "Agency",
    type: "collapse",
    icon: <FaRegBuilding size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formagency1",
        title: "Agency registration",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/formagency"
      }
    ]
  },
  {
    id: "formagent",
    title: "Agent",
    type: "collapse",
    icon: <FaUser size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formagent1",
        title: "Register",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/formagent"
      }
    ]
  },
  {
    id: "upload",
    title: "Upload",
    type: "collapse",
    icon: <FaFileUpload size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "uploadagent",
        title: "File agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadagent"
      },
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
      {
        id: "renewupload",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renewupload"
      }
    ]
  },
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportprenew",
        title: "Prenew",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportprenew"
      },
      {
        id: "reportappointmentsales1",
        title: "In proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsale"
      },
      {
        id: "salesreport4",
        title: "Delete sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/deleteAppointmentsell"
      },
      /* {
        id: "salesreport5",
        title: "Recovery sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/recoveryappointmentsalesproccesor"
      }, */
    ]
  },
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "In Proccessing renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosedproccesor"
      },
       {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
  {
    id: "reportbackofice",
    title: "Report BackOffice",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportSpeakEnglish",
        title: "Speak English",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/speak"
      },
      {
        id: "reportOver65YearsOld",
        title: "Over 65 years old",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/over"
      },
      {
        id: "reportNotInterested",
        title: "Not interested",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/notinterested"
      },
      {
        id: "reportIncorrectNumbers",
        title: "Incorrect or invalid numbers",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/incorrectnumbers"
      },
      {
        id: "reportHasworkinsurance",
        title: "Has Work Insurance",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/hasworinsurance"
      },
      {
        id: "reportNoanswer",
        title: "No answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswe"
      }
    ]
  },
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "statusfinishsales1",
        title: "Terminated",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "reportstatusfinishsalescan2",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2si",
        title: "Recovery",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescasi"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Actived",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportsalesconsultor",
        title: "Pay",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesconsultor"
      },
    ]
  },
  {
    id: "statusfinishsalesmonth",
    title: "Report Months",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "statusfinishsales1",
        title: "List",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesmonth"
      },
    ]
  },
  {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "InProccessing",
        title: "In Proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/InProcessingOther"
      },
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
      {
        id: "Delete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/DeleteOther"
      },
    ]
  },
]

const navigationAuditor = [
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsale"
      },
    ]
  },
]

const navigationSuperadmin = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  /* {
    id: "formconfig",
    title: "Setting",
    type: "collapse",
    icon: <FaCog size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formugoals",
        title: "Goals",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/goalsform"
      },
    ]
  }, */
  /* {
    id: "formuser",
    title: "Users",
    type: "collapse",
    icon: <FaUserCog size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formuser1",
        title: "User Form",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/userform"
      },
      {
        id: "formuser2",
        title: "Report",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportlogin"
      }
    ]
  }, */
  /* {
    id: "formomabacare",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  }, */
  /* {
    id: "formagency",
    title: "Agency",
    type: "collapse",
    icon: <FaRegBuilding size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formagency1",
        title: "Agency registration",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/formagency"
      }
    ]
  }, */
  /* {
    id: "formagent",
    title: "Agent",
    type: "collapse",
    icon: <FaUser size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formagent1",
        title: "Register",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/formagent"
      },
      {
        id: "salesMonth",
        title: "Months",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/salesMonth"
      }
    ]
  }, */
 /*  {
    id: "upload",
    title: "Upload",
    type: "collapse",
    icon: <FaFileUpload size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "uploadagent",
        title: "File agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadagent"
      },
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      }
    ]
  }, */
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportprenew",
        title: "Prenew",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportprenew"
      },
      {
        id: "reportappointmentsales1",
        title: "In processing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsale"
      },
      {
        id: "salesreport4",
        title: "Delete sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/deleteAppointmentsell"
      },
      /* {
        id: "salesreport5",
        title: "Recovery sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/recoveryappointmentsalesproccesor"
      }, */
    ]
  },
  /* {
    id: "reportbackofice",
    title: "Report BackOffice",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportSpeakEnglish",
        title: "Speak English",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/speak"
      },
      {
        id: "reportOver65YearsOld",
        title: "Over 65 years old",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/over"
      },
      {
        id: "reportNotInterested",
        title: "Not interested",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/notinterested"
      },
      {
        id: "reportIncorrectNumbers",
        title: "Incorrect or invalid numbers",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/incorrectnumbers"
      },
      {
        id: "reportHasworkinsurance",
        title: "Has Work Insurance",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/hasworinsurance"
      },
      {
        id: "reportNoanswer",
        title: "No answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswe"
      }
    ]
  }, */
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
      {
        id: "reportsalesconsultor",
        title: "Pay",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesconsultor"
      },
    ]
  },
  /* {
    id: "statusfinishsalesmonth",
    title: "Report Months",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "statusfinishsales1",
        title: "List",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesmonth"
      },
    ]
  }, */
  /* {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
    ]
  }, */
]

const navigatorSupervisor = [
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formomabacareS",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1S",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "salesreport",
    title: "My Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreportCS1",
        title: "Draft sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellDraft"//Ventas propias en borrador por el usuario
      },
      {
        id: "salesreportCS2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellCS"//Ventas propias pendientes por el usuario
      },
      {
        id: "salesreport3",
        title: "Closed Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesbyagents"
      },
    ]
  },
  {
    id: "generalsalesreport",
    title: "Sales Reports",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportpending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportpending"
      },
      {
        id: "generalsalesreportclosed",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportclosed"
      },
      /* {
        id: "generalsalesreportdelete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportdelete"
      },
      {
        id: "generalsalesreportcancelled",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportcancelled"
      },*/
    ]
  },
  {
    id: "upload",
    title: "Upload",
    type: "collapse",
    icon: <FaFileUpload size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "uploadagent",
        title: "File agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadagent"
      },
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
    ]
  },
  /* {
    id: "upload2",
    title: "Phone list",
    type: "collapse",
    icon: <FaPhoneAlt size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
      {
        id: "reportNodocument",
        title: "No Answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswerselles"
      }
    ]
  }, */
]

const navigatorSupport = [
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formuser",
    title: "Users",
    type: "collapse",
    icon: <FaUserCog size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "formuser1",
        title: "User Form",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/userform"
      },
      {
        id: "formuser2",
        title: "Report",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportlogin"
      }
    ]
  },
  {
    id: "upload",
    title: "Upload",
    type: "collapse",
    icon: <FaFileUpload size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "uploadagent",
        title: "File agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadagent"
      },
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
      {
        id: "renewupload",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renewupload"
      }
    ]
  },
  {
    id: "generalsalesreport",
    title: "Sales Reports",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportprenewsupport",
        title: "Prenew",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportprenewsupport"
      },
    ]
  },
  {
    id: "reportbackofice",
    title: "Report BackOffice",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportSpeakEnglish",
        title: "Speak English",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/speak"
      },
      {
        id: "reportOver65YearsOld",
        title: "Over 65 years old",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/over"
      },
      {
        id: "reportNotInterested",
        title: "Not interested",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/notinterested"
      },
      {
        id: "reportIncorrectNumbers",
        title: "Incorrect or invalid numbers",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/incorrectnumbers"
      },
      {
        id: "reportHasworkinsurance",
        title: "Has Work Insurance",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/hasworinsurance"
      },
      {
        id: "reportNoanswer",
        title: "No answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswe"
      }
    ]
  },
]

const navigatorAgent2 = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formomabacare",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "salesreport",
    title: "Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "reportappointmentsales1",
        title: "Sales in processing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      }, */
      {
        id: "salesreport2",
        title: "Draft Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/draftAppointmentsell"
      },
      {
        id: "salesreport4",
        title: "Processing Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/processingsalesbyagents"
      },
      {
        id: "salesreport5",
        title: "Pending Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "salesreport3",
        title: "Closed Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesbyagents"
      },
      {
        id: "salesreport6",
        title: "Renovation Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsell"
      },
    ]
  },
  {
    id: "upload",
    title: "Phone list",
    type: "collapse",
    icon: <FaPhoneAlt size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
      {
        id: "reportNodocument",
        title: "No Answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswerselles"
      }
    ]
  },
]

const navigatorProcessor = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportappointmentsales1",
        title: "In proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "closedappointmentsalesproccesorpendupload",
        title: "Closed sales Pend. Upload",
        type: "item",
        /* badge: "success",
        badgeText: "3", */
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesorpendupload"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesor"
      },
      /* {
        id: "closedappointmentsalesproccesorss",
        title: "Closed sales Social",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesorss"
      }, */
      {
        id: "closedappointmentsalesproccesornoss",
        title: "Closed sales NO Social",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesornoss"
      },
      {
        id: "salesreport4",
        title: "Delete sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/deleteAppointmentsell"
      },
      /* {
        id: "salesreport5",
        title: "Recovery sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/recoveryappointmentsalesproccesor"
      }, */
      {
        id: "appointmentsalelifechange",
        title: "Life Change",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsalelifechange"
      },
    ]
  },
  /* {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "InProccessing",
        title: "In Proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/InProcessingOther"
      },
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
      {
        id: "Delete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/DeleteOther"
      },
      {
        id: "Renovation",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/RenewOther"
      },
    ]
  }, */
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "salesreport3",
        title: "Pending for status",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesempty"
      }, */
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "reportstatusfinishsales2si",
        title: "Recovery",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescasi"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
    ]
  },
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "In Proccessing renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosedproccesor"
      },
      {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
]

const navigatorRecoveryMaster = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportappointmentsales1",
        title: "In proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "closedappointmentsalesproccesorpendupload",
        title: "Closed sales Pend. Upload",
        type: "item",
        /* badge: "success",
        badgeText: "3", */
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesorpendupload"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesor"
      },
      /* {
        id: "closedappointmentsalesproccesorss",
        title: "Closed sales Social",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesorss"
      }, */
      {
        id: "closedappointmentsalesproccesornoss",
        title: "Closed sales NO Social",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/closedappointmentsalesproccesornoss"
      },
      {
        id: "salesreport4",
        title: "Delete sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/deleteAppointmentsell"
      },
      /* {
        id: "salesreport5",
        title: "Recovery sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/recoveryappointmentsalesproccesor"
      }, */
      {
        id: "appointmentsalelifechange",
        title: "Life Change",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsalelifechange"
      },
    ]
  },
  /* {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "InProccessing",
        title: "In Proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/InProcessingOther"
      },
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
      {
        id: "Delete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/DeleteOther"
      },
      {
        id: "Renovation",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/RenewOther"
      },
    ]
  }, */
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "salesreport3",
        title: "Pending for status",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesempty"
      }, */
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "reportstatusfinishsales2si",
        title: "Recovery",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescasi"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
      {
        id: "reportsalesconsultor",
        title: "Pay",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesconsultor"
      },
    ]
  },
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "In Proccessing renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosedproccesor"
      },
       {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
]

const navigatorCustomerServiceLeader = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  /* {
    id: "formagent",
    title: "Agent",
    type: "collapse",
    icon: <FaUser size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesMonth",
        title: "Months",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/salesMonth"
      }
    ]
  }, */
  {
    id: "salesreport",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportappointmentsales1",
        title: "Sales in processing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsale"
      },
      {
        id: "salesreport4",
        title: "Delete sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/deleteAppointmentsell"
      },
      {
        id: "appointmentsalelifechange",
        title: "Life Change",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsalelifechange"
      },
    ]
  },
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "salesreport3",
        title: "Pending for status",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesempty"
      }, */
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
    ]
  },
  /* {
    id: "statusfinishsalesmonth",
    title: "Report Months",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "statusfinishsales1",
        title: "List",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesmonth"
      },
    ]
  }, */
  /* {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "InProccessing",
        title: "In Proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/InProcessingOther"
      },
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
      {
        id: "Delete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/DeleteOther"
      },
      {
        id: "Renovation",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/RenewOther"
      },
    ]
  }, */
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "In Proccessing renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosedproccesor"
      },
       {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
]

const navigatorCustomerService = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formomabacare",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "salesreport",
    title: "My Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreportCS1",
        title: "Draft sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellDraft"//Ventas propias en borrador por el usuario
      },
      {
        id: "salesreportCS2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellCS"//Ventas propias pendientes por el usuario
      },
      {
        id: "salesreportCS3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsaleCS"//Ventas propias vendidas por el usuario
      },
    ]
  },
  {
    id: "salesreport_1",
    title: "Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "reportappointmentsales1",
        title: "Sales in processing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/prenewappointmentsell"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "salesreport3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsale"
      },
      {
        id: "appointmentsalelifechange",
        title: "Life Change",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsalelifechange"
      },
    ]
  },
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "salesreport3",
        title: "Pending for status",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesempty"
      }, */
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
      {
        id: "reportstatusfinishsales2no",
        title: "Disqualify",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescano"
      },
    ]
  },
 /*  {
    id: "salesOthers",
    title: "Sales Others",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "InProccessing",
        title: "In Proccessing",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/InProcessingOther"
      },
      {
        id: "Pending",
        title: "Pending",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/PendingOther"
      },
      {
        id: "ClosedOther",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/ClosedOther"
      },
      {
        id: "Delete",
        title: "Delete",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/DeleteOther"
      },
      {
        id: "Renovation",
        title: "Renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/RenewOther"
      },
    ]
  }, */
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "In Proccessing renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosedproccesor"
      },
       {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
]

const navigatorQualityLeader = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formomabacareS",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1S",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "salesreport",
    title: "My Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreportCS1",
        title: "Draft sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellDraft"//Ventas propias en borrador por el usuario
      },
      {
        id: "salesreportCS2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellCS"//Ventas propias pendientes por el usuario
      },
      {
        id: "salesreport3",
        title: "Closed Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesbyagents"
      },
    ]
  },
  {
    id: "generalsalesreport",
    title: "Sales Reports",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "SearchNumberAndName",
        title: "Search",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/search"
      }, */
      {
        id: "generalsalesreportprenew",
        title: "Prenew",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportprenew"
      },
      {
        id: "salesreport2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsell"
      },
      {
        id: "generalsalesreportclosed",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportclosed"
      },
      /* {
        id: "generalsalesreportcancelled",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportcancelled"
      }, */
    ]
  },
  /* {
    id: "renovationsalesreport",
    title: "Sales Renovation",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "renovationsalesreportprenew",
        title: "Prenew renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportprenew"
      },
      {
        id: "renovationsalesreportclosed",
        title: "Closed renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportclosed"
      },
       {
        id: "renovationsalesreportcancelled",
        title: "Cancelled renovation",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/renovationsalesreportcancelled"
      },
    ]
  }, */
  /* {
    id: "upload",
    title: "Upload",
    type: "collapse",
    icon: <FaFileUpload size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "uploadagent",
        title: "File agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/uploadagent"
      }
    ]
  },
  {
    id: "upload2",
    title: "Phone list",
    type: "collapse",
    icon: <FaPhoneAlt size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "agentupload",
        title: "Agent",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/agentupload"
      },
      {
        id: "reportNodocument",
        title: "No Answer",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/noanswerselles"
      }
    ]
  },*/
]

const navigatorQualityAux = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
  {
    id: "formomabacare",
    title: "Obama care",
    type: "collapse",
    icon: <FaListUl size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport1",
        title: "New sale",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/newappointmentsell"
      }
    ]
  },
  {
    id: "salesreport",
    title: "My Sales Report",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreportCS1",
        title: "Draft sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellDraft"//Ventas propias en borrador por el usuario
      },
      {
        id: "salesreportCS2",
        title: "Pending sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/pendingAppointmentsellCS"//Ventas propias pendientes por el usuario
      },
      {
        id: "salesreportCS3",
        title: "Closed sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/appointmentsaleCS"//Ventas propias vendidas por el usuario
      },
    ]
  },
  {
    id: "generalsalesreport",
    title: "Sales Reports",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportprenew",
        title: "Prenew",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportprenew"
      },
      {
        id: "generalsalesreportclosed",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportclosed"
      },
    ]
  },
]

const navigatorNPN = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "generalsalesreport",
    title: "Sales Reports",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "generalsalesreportclosed",
        title: "Closed",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/generalsalesreportclosed"
      },
    ]
  },
]

const navigatorConsultor = [
  {
    id: "home",
    title: "Homepage",
    type: "item",
    icon: <FaHome size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "salesreport",
    title: "Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "salesreport3",
        title: "Closed Sales",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportsalesconsultor"
      }
    ]
  },
  {
    id: "statusfinishsales",
    title: "Status Finish Sales",
    type: "collapse",
    icon: <FaDatabase size={size} />,
    permissions: ["admin", "editor"],
    children: [
      /* {
        id: "salesreport3",
        title: "Pending for status",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesempty"
      }, */
      {
        id: "reportstatusfinishsales2",
        title: "Other Party",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesca"
      },
      {
        id: "statusfinishsales1",
        title: "Termined",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesop"
      },
      {
        id: "reportstatusfinishsales3",
        title: "Active",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalesac"
      },
      {
        id: "reportstatusfinishsales4",
        title: "Cancelled",
        type: "item",
        icon: <FaCheck size={size} />,
        permissions: ["admin", "editor"],
        navLink: "/reportstatusfinishsalescancelled"
      },
    ]
  },
  {
    id: "email",
    title: "Email",
    type: "item",
    icon: <FaEnvelope size={size} />,
    permissions: ["admin", "editor"],
    navLink: "/email"
  },
]


const navigationConfig =
  user?.profile === 7 ? navigationSuperadmin ://Superadmin
    user?.profile === 104 ? navigatorSupervisor ://Supervisor
      user?.profile === 106 ? navigatorSupport ://Support
        user?.profile === 118 ? navigatorAgent2 ://Agente
          user?.profile === 211 ? navigatorProcessor ://Processor
              user?.profile === 219 ? navigatorCustomerServiceLeader ://Customer Service Leader
                user?.profile === 227 ? navigatorCustomerService ://Customer Service
                  user?.profile === 238 ? navigatorQualityLeader ://Quality Leader
                    user?.profile === 239 ? navigatorQualityAux ://Quality Aux
                      user?.profile === 251 ? navigationSuperadminTop ://SuperadminTop
                        user?.profile === 255 ? navigationAuditor ://Auditor
                          user?.profile === 256 ? navigatorRecoveryMaster ://Recovery Master
                            user?.profile === 265 ? navigatorNPN ://NPN
                              user?.profile === 275 ? navigatorConsultor ://Consultor
          []

export default navigationConfig
